import { useSEO } from '../../utils/seo';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustIndicators from './components/TrustIndicators';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.lineflow.com.au';

  useSEO({
    title: 'LineFlow Underground & Civil - Professional Plumbing & Civil Engineering Services',
    description: 'LineFlow Underground & Civil specializes in new home plumbing installation and underground civil engineering projects. Professional quality, reliable service with 10+ years of experience. Licensed and fully insured.',
    keywords: 'plumbing services, new home plumbing, underground piping, civil engineering, residential plumbing, commercial plumbing, LineFlow',
    canonical: `${siteUrl}/`,
    ogType: 'website',
    ogTitle: 'LineFlow Underground & Civil - Professional Plumbing Services',
    ogDescription: 'Specializing in new home plumbing installation and underground civil engineering projects. Licensed, insured, and experienced.',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': `${siteUrl}/#organization`,
          name: 'LineFlow Underground & Civil',
          url: siteUrl,
          logo: {
            '@type': 'ImageObject',
            url: `${siteUrl}/logo.png`
          },
          description: 'Professional plumbing and civil engineering services specializing in new home plumbing installation and underground infrastructure projects.',
          address: {
            '@type': 'PostalAddress',
            addressCountry: 'AU'
          },
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'Customer Service',
            availableLanguage: 'English'
          }
        },
        {
          '@type': 'LocalBusiness',
          '@id': `${siteUrl}/#localbusiness`,
          name: 'LineFlow Underground & Civil',
          image: `${siteUrl}/logo.png`,
          url: siteUrl,
          telephone: '',
          priceRange: '$$',
          address: {
            '@type': 'PostalAddress',
            addressCountry: 'AU'
          },
          geo: {
            '@type': 'GeoCoordinates'
          },
          openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '07:00',
            closes: '17:00'
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '127'
          }
        },
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'LineFlow Underground & Civil',
          description: 'Professional plumbing and civil engineering services',
          publisher: {
            '@id': `${siteUrl}/#organization`
          }
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: siteUrl,
          name: 'LineFlow Underground & Civil - Professional Plumbing & Civil Engineering Services',
          isPartOf: {
            '@id': `${siteUrl}/#website`
          },
          about: {
            '@id': `${siteUrl}/#organization`
          },
          description: 'LineFlow Underground & Civil specializes in new home plumbing installation and underground civil engineering projects. Professional quality, reliable service with 10+ years of experience.'
        }
      ]
    }
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <TrustIndicators />
      <Services />
      <Testimonials />
      <CTABanner />
      <Footer />
    </div>
  );
}
